import React, { useState } from 'react';
import { FaMapMarkerAlt, FaSearch, FaPhoneAlt } from 'react-icons/fa';
import { getAvailableOrganizationSettings } from '../redux/auth/authSlice';
import { useSelector } from 'react-redux';
import { useThemeColors } from '../hooks/useThemeColors';

const StoreLocator = ({ onClose, darkMode }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const organizationSettings = useSelector(getAvailableOrganizationSettings);
  const {
    contentBg,
    cardBg,
    textColor,
    subTextColor,
    borderColor,
    headerBg,
    isDark,
  } = useThemeColors(darkMode);

  const stores = [
    // {
    //   id: 1,
    //   name: 'Shabbaz',
    //   address:
    //     '36, D1A Phase 6 Phase 6 Defence Housing Authority, Karachi, Karachi City, Sindh 75500, Pakistan',
    //   hours: '12:00 PM - 03:00 AM',
    // },
    // {
    //   id: 2,
    //   name: 'Boat Basin',
    //   address:
    //     'Bus Stop, Khayabian-e-Roomi, Block 5 Zone C Block 7 Citron, Karachi, Karachi City, Sindh 75600, Pakistan',
    //   hours: '12:00 PM - 03:00 AM',
    // },
    // {
    //   id: 3,
    //   name: 'Defence 26th Street',
    //   address:
    //     '2nd Floor, 21-C, 26th Street, Bidar Commercial, Phase V Bidar Commercial Area Defence V Defence Housing Authority, Karachi, Karachi City, Sindh 75500, Pakistan',
    //   hours: '12:00 PM - 03:00 AM',
    // },
  ];

  const filteredStores = stores.filter(
    (store) =>
      store.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      store.address.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div
      className="store-locator-page"
      style={{
        backgroundColor: contentBg, // Wrapper background
        minHeight: '100vh',
        color: textColor,
        transition: '0.3s ease',
      }}
    >
      <div className="container py-4">
        <h4 className="mb-0 fw-bold mb-3" style={{ color: textColor }}>
          Find a Store Nearby
        </h4>
        {/* Search Box */}
        <div
          className="search-box-wrapper mb-4 p-2 rounded-pill d-flex align-items-center px-3"
          style={{
            backgroundColor: isDark ? 'rgba(255,255,255,0.05)' : '#f1f1f1',
            border: `1px solid ${borderColor}`,
          }}
        >
          <FaSearch className="me-2" style={{ color: subTextColor }} />
          <input
            type="text"
            className="form-control border-0 bg-transparent"
            placeholder="Search city, area or store name..."
            style={{ color: textColor, boxShadow: 'none' }}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {/* Stores List */}
        <div className="stores-list row g-3">
          {/* Main Organization Store */}
          {organizationSettings && (
            <div className="col-12">
              <div
                className="store-card p-4 rounded-4 shadow-sm border-0"
                style={{
                  backgroundColor: cardBg,
                  border: `1px solid ${borderColor}`,
                }}
              >
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div>
                    <h5 className="fw-bold mb-1" style={{ color: textColor }}>
                      {organizationSettings.displayName}
                    </h5>
                    <span
                      className="small opacity-75"
                      style={{ color: subTextColor }}
                    >
                      {organizationSettings.email}
                    </span>
                  </div>
                  <div className="badge bg-success rounded-pill px-3 py-2">
                    Main Branch
                  </div>
                </div>

                <div
                  className="divider mb-3"
                  style={{
                    borderBottom: `1px solid ${borderColor}`,
                    opacity: 0.2,
                  }}
                ></div>

                <div className="store-info d-flex flex-column gap-2">
                  <div className="d-flex align-items-start gap-2">
                    <FaMapMarkerAlt className="text-danger mt-1" />
                    <p className="mb-0 small" style={{ color: subTextColor }}>
                      <span
                        className="fw-bold d-block"
                        style={{ color: textColor }}
                      >
                        Address:
                      </span>
                      {organizationSettings.physicalAddress}
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <FaPhoneAlt className="text-danger" />
                    <p className="mb-0 small" style={{ color: subTextColor }}>
                      <span
                        className="fw-bold me-1"
                        style={{ color: textColor }}
                      >
                        Phone:
                      </span>
                      {organizationSettings.phoneNumber}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Filtered Stores */}
          {filteredStores.map((store) => (
            <div key={store.id} className="col-md-6">
              <div
                className="store-card h-100 p-4 rounded-4 shadow-sm border-0 transition-all"
                style={{
                  backgroundColor: cardBg, // Card style background
                  border: `1px solid ${borderColor}`,
                }}
              >
                <h5 className="fw-bold mb-3" style={{ color: textColor }}>
                  {store.name}
                </h5>
                <div
                  className="divider mb-3"
                  style={{
                    borderBottom: `1px solid ${borderColor}`,
                    opacity: 0.2,
                  }}
                ></div>

                <div className="d-flex flex-column gap-3">
                  <div className="d-flex align-items-start gap-2">
                    <FaMapMarkerAlt className="text-danger mt-1" />
                    <p className="mb-0 small" style={{ color: subTextColor }}>
                      {store.address}
                    </p>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="px-2 py-1 rounded small"
                      style={{
                        backgroundColor: isDark
                          ? 'rgba(255,255,255,0.1)'
                          : 'rgba(0,0,0,0.05)',
                        color: textColor,
                      }}
                    >
                      {store.hours}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer info */}
      {/*<div
        className="pickup-footer mt-5 p-4 text-center fw-bold sticky-bottom"
        style={{
          backgroundColor: headerBg, // Navbar style background
          borderTop: `1px solid ${borderColor}`,
          color: textColor,
        }}
      >
        <p className="mb-0">📍 Default Pickup: Millennium Mall Branch</p>
      </div>*/}
    </div>
  );
};

export default StoreLocator;
